<template>
  <div style="padding:20px;" class="bloc has-text-centered">
    <!-- text thanks -->
    <h2 v-if="sondage_thanks == null">{{ $t("remerciements.thanks") }}</h2>
    <h2 v-else>{{ sondage_thanks }}</h2>
    <div>
      <hr />
      <!-- next -->
      <button
        style="width:auto"
        v-if="this.sondage_type === 'block' && showResultsClient && !this.$store.getters.iframeColidee"
        class="button-client"
        @click="resultats"
      >
        <b-icon pack="fas" icon="chart-pie" size="is-small"></b-icon>
        {{ " " }}{{ $t("button.SeeAllChart") }}
      </button>
      <button
        :loading="this.sondage_type === 'replay' ? isLoading : false"
        class="button-client"
        @click="resetTimer()"
      >
        {{
          $tc("button.remerciements.sondage_return", sondage_type === "replay")
        }}
      </button>
    </div>
    <p
      style="margin-top:20px;font-size:10px;"
      v-if="this.sondage_type !== 'block'"
    >
      {{ $t("remerciements.redirected") }}{{ increment }}{{ " "
      }}{{ $tc("remerciements.seconds", increment > 1) }}
    </p>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
import { mapGetters } from 'vuex'
export default {
  name: 'Thanks',
  props: {
    viewColidee: {
      required: true
    },
    colidee: {
      required: true
    },
    sondage_type: {
      type: String,
      required: true
    },
    sondage_thanks: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      timer: 0,
      increment: 5,
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(['steps', 'type_formulaire', 'showResultsClient'])
  },
  created () {
    if (this.sondage_type !== 'block') {
      EventBus.$on('counter_thanks-component', this.counterDown)
    }
  },
  beforeDestroy () {
    if (this.sondage_type !== 'block') {
      EventBus.$off('counter_thanks-component')
    }
  },
  methods: {
    resultats () {
      // on accéde aux résultats du groupe de participants avec l'url 'client'
      // pour limiter le risque d'utilisation de l'url 'modérateur'
      var url = window.location.href
      var code = url.substring(url.length - 6)
      var language = this.$store.getters.choosenLanguageClient
      window.location =
        process.env.URL_SONDAGES + '/r-' + code + '/' + language
    },
    counterDown () {
      this.isLoading = false
      this.timer = setInterval(() => {
        if (this.increment > 1) {
          this.increment -= 1
        } else if (this.increment === 1) {
          this.$store.commit('IS_LOADING_PUBLIC', true)
          this.increment -= 1
        } else if (this.increment === 0) {
          this.resetTimer()
        }
      }, 1000)
    },
    resetTimer () {
      if (this.$store.getters.authorizedPreview) {
        this.$store.commit('CHANGE_LANGUE', 'fr')
        this.$router.push({ name: 'Admin' })
      }
      if (this.viewColidee) {
        clearInterval(this.timer)
        let message = { task: 'finSondage' }
        window.top.postMessage(message, '*')
      } else {
        clearInterval(this.timer)
        EventBus.$emit('resetForm_client')
        setTimeout(function () {
          EventBus.$emit('choosenLanguageComponentEmit', true)
        }, 400)
      }
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 18px;
}
.remerciements {
  height: 300px;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/Thanks.vue